import { Injectable } from '@angular/core'

import { BaseService } from './base.service'

import { environment } from '../../environments/environment'

const BASE_URL = document.getElementsByTagName('base')[0].href
console.log('BASE_URL', document.getElementsByTagName('base')[0].href)

const DEFAULTS = {
  title: 'Air Configurator Devel',
  graphql_endpoint: 'http://localhost:4567/graphql',
  graphql_ws_endpoint: 'ws://localhost:4567/graphql',
  files_endpoint: 'http://localhost:4567/files',
  no_basket: false
}

const PRODUCTION = {
  title: 'Air Configurator Production',
  graphql_endpoint: BASE_URL + 'graphql',
  graphql_ws_endpoint: BASE_URL.replace('http', 'ws') + 'graphql',
  files_endpoint: BASE_URL + 'files',
  no_basket: false
}

@Injectable()
export class ConfigService extends BaseService {

  CONFIG: any = {}

  constructor() {
    super()
    console.log('ConfigService constructor', this.getId())
    this.CONFIG = { ...this.CONFIG, ...DEFAULTS }
    if (environment.production) {
      this.CONFIG = { ...this.CONFIG, ...PRODUCTION }
    }
    console.log('CONFIG', this.CONFIG)
  }

}
